import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Log } from '@s8l/client-tree-lib';

import { AggregationGroup, StatsServerService } from 'src/app/services/jsonrpc/stats-server.service';

export interface Option {
  label: string;
  title?: string;
  values: string[];
}

@Component({
  selector: 'app-dashboard-filter',
  templateUrl: './dashboard-filter.component.html',
  styleUrls: ['./dashboard-filter.component.scss']
})
export class DashboardFilterComponent implements OnInit {
  @Input() public labels?: string[];
  @Output() public onUpdate = new EventEmitter<[NgbDate, NgbDate, { [key: string | AggregationGroup]: string }]>();

  public options: Option[] = null;

  public from: NgbDate;
  public to: NgbDate;
  public filter: { [key: string | AggregationGroup]: string } = {};

  constructor(private stats: StatsServerService) {}

  public ngOnInit(): Promise<any> {
    if (!this.labels) {
      this.options = [];
      return Promise.resolve();
    }
    return this.stats
      .adminLabelList()
      .then(kvs => {
        this.options = this.labels
          .map(label => {
            const opt = kvs.find(kv => kv.key === label);
            const title = label.charAt(0).toUpperCase() + label.substring(1);
            return opt?.values ? { label, title, values: opt.values.sort() } : null;
          })
          .filter(o => o);
      })
      .catch(err => {
        this.options = [];
        Log.error('Failed to fetch label options', err);
      });
  }

  public apply(): void {
    this.onUpdate.emit([this.from, this.to, this.filter]);
  }

  public reset(): void {
    this.from = null;
    this.to = null;
    this.filter = {};
    this.apply();
  }

  public setLabelFilter(option: Option, value?: string): void {
    if (value) this.filter[option.label] = value;
    else delete this.filter[option.label];
  }
}
